import React, {useState} from "react"
import { Link } from "gatsby";
import ShareImage from '../../images/icons/share.png'
import LikeImage from '../../images/icons/like.png'
import LikeIconActive from '../../images/icons/like-active.png';
import "./wideWiseTip.scss"
import SocialShare from '../common/SocialButtons';
import PwMarkdown from '../common/PWMarkdown';
import { api } from '../../../utils';

const WideWiseTipCard = (props) => {
    const [openCls, setOpenCls] = useState(false)
    const { data, type, location, user, bookmarks, fetchBookmarks } = props;
    const acf = type === 'wiseSpeak' ? data.acf_wise_speak : data.acf_wise_self;
    const ref = type === 'wiseSpeak' ? 'wise-speak' : 'wise-self'

    const bookmarkTip = (slug) => {
        const fData = {
            type: 'wise-journey',
            slug
        }
        api.post('/api/v1/user-bookmark/toggle', fData)
        .then(resp => {
            if (resp && resp.success) {
                fetchBookmarks();
            } else {
                alert("Something went wrong. Please try again later!");
            }
        });
    }

    return (
        <div className="w3-padding-32 wideWiseTipMainCard">
            <Link to={`/${ref}#${data.slug}`} className="card size">
                <div className='w3-col s12 wideWiseTipBackground wideWiseTipCard'>
                    <div className="wideWiseTipHeader">Bring these tips to life through our upcoming WiseJourney!</div>
                    <div className="wideWiseTipBorder"></div>
                    <div className="wideWiseTipTitle">{type === 'wiseSpeak' ? 'WISESPEAK' : 'WISESELF'}</div>
                    <div className="wideWiseDate">{acf.date}</div>
                    <div className='wideWiseTipContent'><PwMarkdown data={acf.description} /></div>
                    <div className='wideWiseTipAllign w3-col s12 w3-margin-top'>
                        <div className='w3-margin-right w3-margin-top'> 
                            {(user) && (
                                <button style={{ background: 'none', padding: '0px', border: 'none', outline: 'none', cursor: 'pointer' }}
                                    onClick={(evt) => {
                                        evt.preventDefault();
                                        evt.stopPropagation();
                                        bookmarkTip(data.slug);
                                    }}
                                > 
                                    <img className="like-img" src={(bookmarks.indexOf(data.slug) !== -1) ? LikeIconActive : LikeImage} />
                                </button>
                            )}
                        </div>
                        <div className={`share-img w3-margin-top ${!openCls ? "w3-show" : "w3-hide"}`}> 
                            <img src={ShareImage} onClick={(evt) => {
                                evt.preventDefault();
                                evt.stopPropagation();
                                setOpenCls(true)
                            }} /> 
                        </div>
                        <SocialShare data={openCls} handleSetOpenCls={(someData) => {setOpenCls(someData)}} 
                            title={data.title} link={`${location.origin}/${ref}#${data.slug}`} 
                            subjectTitle={'Check out this journey!'} description={acf.description}
                        />
                    </div>
                </div>
            </Link>
        </div>
    )
}

export default WideWiseTipCard
